import dayjs from "dayjs";

const EMPTY_LOCALIZED = { fr: "", en: "", ar: "" };

const toLocalized = (value) => ({
  ...EMPTY_LOCALIZED,
  ...(value || {}),
});

const appendJson = (formData, key, value) => {
  formData.append(key, JSON.stringify(value));
};

export const buildPromotionPayload = ({
  values,
  isEditing = false,
  hadMainImage = false,
}) => {
  const formData = new FormData();
  const formations = values?.formations || [];
  const journeySteps = (values?.journeySteps || []).map((step) => ({
    title: toLocalized(step?.title),
    description: toLocalized(step?.description),
  }));

  appendJson(formData, "badge", toLocalized(values?.badge));
  formData.append("startDate", dayjs(values?.startDate).toISOString());
  formData.append("endDate", dayjs(values?.endDate).toISOString());

  appendJson(formData, "mainTitle", toLocalized(values?.mainTitle));
  appendJson(formData, "mainDescription", toLocalized(values?.mainDescription));

  appendJson(formData, "offerTitle", toLocalized(values?.offerTitle));
  appendJson(formData, "offerDescription", toLocalized(values?.offerDescription));

  appendJson(formData, "formations", formations);

  appendJson(formData, "journeyTitle", toLocalized(values?.journeyTitle));
  appendJson(
    formData,
    "journeyDescription",
    toLocalized(values?.journeyDescription)
  );
  appendJson(formData, "journeySteps", journeySteps);

  const mainImageFile = values?.mainImage?.[0]?.originFileObj;
  if (mainImageFile) {
    formData.append("mainImage", mainImageFile);
  }

  const shouldRemoveMainImage =
    isEditing &&
    hadMainImage &&
    !mainImageFile &&
    (!values?.mainImage || values.mainImage.length === 0);

  if (shouldRemoveMainImage) {
    formData.append("removeMainImage", "true");
  }

  return formData;
};
